import Skeleton from 'react-loading-skeleton'

export function DateSelectionCalendarSkeleton() {
  return (
    <div>
      {/* Week day headers */}
      <div className="mb-2 grid grid-cols-7 gap-2">
        {['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'].map((day) => (
          <div key={day} className="text-center text-xs font-medium tracking-wider text-slate-400 uppercase">
            {day}
          </div>
        ))}
      </div>

      {/* Calendar dates grid skeleton - 3 weeks (21 days) */}
      <div className="grid grid-cols-7 gap-2">
        {Array.from({ length: 21 }).map((_, index) => (
          <div key={index} className="flex flex-col items-center">
            <Skeleton height={72} className="w-full rounded-md" containerClassName="w-full" />
          </div>
        ))}
      </div>
    </div>
  )
}
